import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import styled from 'styled-components';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import '../../microservice/container/sidebar.css';
import '../../Style/defaultstyle.css'
import CommonTable from '../../container/Table/Components/CommonTable';
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import config from '../../microservice/components/config-en';
import Sidebar from '../../container/Sidebar/Sidebar';
import { useTranslation } from "react-i18next";

// add
import CardBox from '../../container/Box/Components/CardBox';
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-en';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import FooterEn from '../../detailpageVN/Page/component/footeren';
import HeaderEn from '../../detailpageVN/Page/component/headeren';
import SidebarEn from '../../container/Sidebar/Sidebar-en';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;
// Titlecloudcompute
function MSA3ENG() {
    const { t } = useTranslation();
    const isMobile = useIsMobile();

    return (
        <Sysfont className='App'>
            <HeaderEn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarEn />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("어플리케이션 통합과 서비스")} */}
                        <BoxContent>
                            <MuiGrid container spacing={3}>
                                <MuiGrid item xs={12} sm={12}>{CardBox(
                                    "<p class='typo-21 typo-medium typo-black'>Advantages of Microservices Architecture</p>",
                                    `<p class='typo-14'>In applications developed in a microservices architecture, each component and application is divided into small units, enabling easy interoperability, connectivity, and integration between them.
                                    </p><br>
                                    <p class='typo-14'>In addition, customers benefit from faster development, easier updates, and quicker feature additions. This allows them to move away from concerns about updates, patches, and maintenance, and instead focus more on their core business.</p>`
                                )}
                                </MuiGrid>
                                <DividerComponent />
                                <MuiGrid item xs={12} sm={12}>{CardBox(
                                    "<p class='typo-21 typo-medium typo-black'>What Are API Services and Serverless as a Service</p>",
                                    `<p class='typo-14'>These are services where programs, storage, and databases operate on external cloud servers—not on one's own server or a contracted cloud service. They are used in the form of a service, and users only pay for what they use. 
                                    </p></br>
                                    <p class='typo-14'>These services apply application scaling and distributed systems, allowing developers to save time and reduce effort as they do not need to handle programming or infrastructure management directly.</p>`
                                )}
                                </MuiGrid>
                                <DividerComponent />
                                {/*
                                <MuiGrid item xs={12}>{Imagecloudcompute("https://www.hanbiro.com/cloud/library2/cluster-cloud-postgresql-db/postgresql_cluster.svg")}</MuiGrid>
                                */}
                            </MuiGrid>
                            {/* <Boxtitle className='MuiTypography-root MuiTypography-h6 sub-title normal css-y5btr1-MuiTypography-root'>{t('msa_3.line_5')}</Boxtitle> */}
                            <Boxtitle className='MuiTypography-root MuiTypography-h6 sub-title normal css-y5btr1-MuiTypography-root'>Application Service / Serverless Service / Library</Boxtitle>
                            <CommonTable header={config.tb1_header} content={config.tb1_content} />
                        </BoxContent>

                        {/* <CloudConsultCp /> */}
                    </Col>

                </Row>
            </Container>
            <FooterEn />
        </Sysfont>
    );
};


const MuiGrid = styled.div`
    padding: 0px,
`

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px;
    margin-top: 20px;
    margin-bottom: 20px; */}
    text-align: left;
`
const SmallBox = styled.div`
    ${'' /* border: 1px solid #E7EAF3;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    margin-top: 20px; */}
    text-align: left;
`

const Boxtitle = styled.div`
    margin: 20px 5px;
    font-weight: bold;
`


const BoxText = styled.div`
    margin: 20px 5px;
    
`

export default MSA3ENG;